import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import type { AxiosInstance } from "axios";

let serviceMasterApiPromise: Promise<AxiosInstance> | null = null;

const getServiceMasterApi = async (): Promise<AxiosInstance | null> => {
  if (serviceMasterApiPromise !== null) return serviceMasterApiPromise;
  serviceMasterApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return serviceMasterApiPromise;
};

export interface GetServicesListProps {
  Nombre?: string;
  Categoria?: number[];
  UnidadCotizacion?: number[];
  Activo?: boolean;
  "P.Pagina": number;
  "P.Records"?: number;
}

export interface ServiceListItem {
  id: number;
  nombre: string;
  categoria: string;
  unidadCotizacion: string;
  activo: boolean;
}

export interface ServicesListResponse {
  listado: ServiceListItem[];
  totalPages: number;
  totalRecords: number;
}

export const getServicesList = async (props: GetServicesListProps) => {
  const api = await getServiceMasterApi();
  if (!api) return;

  const response = await api.get(
    `/CatalogoServicio/all?${objectToQueryStringWithArray(props)}`,
  );

  return response.data as ServicesListResponse;
};

export interface ServiceDosisUnity {
  id?: number;
  modalidad: number;
  dosisDesde: number;
  dosisHasta: number;
  valorUnitario: number;
}

export interface ServiceDetail {
  id: number;
  titulo: string;
  descripcion?: string;
  valorUnitario?: number;
  categoria: number;
  unidadCotizacion: number;
  activo: boolean;
  cotizacionesDosis: ServiceDosisUnity[];
}

export const getServiceDetail = async (id: number) => {
  const api = await getServiceMasterApi();
  if (!api) return;

  const response = await api.get(`/CatalogoServicio/${id}`);

  return response.data as ServiceDetail;
};

export interface CreateServiceBody {
  titulo: string;
  descripcion: string;
  valorUnitario: number;
  categoria: number;
  unidadCotizacion: number;
  cotizacionesDosis: ServiceDosisUnity[];
}

export const createService = async (body: CreateServiceBody) => {
  const api = await getServiceMasterApi();
  if (!api) return;

  const response = await api.post(`/CatalogoServicio`, body);

  return response.data as string;
};

export interface UpdateServiceBody extends CreateServiceBody {
  id: number;
  activo: boolean;
}

export const updateService = async (body: UpdateServiceBody) => {
  const api = await getServiceMasterApi();
  if (!api) return;

  const { id, ...rest } = body;
  const response = await api.patch(`/CatalogoServicio/${id}`, rest);

  return response.data as string;
};

export const deleteService = async (id: number) => {
  const api = await getServiceMasterApi();
  if (!api) return;

  const response = await api.delete(`/CatalogoServicio/${id}`);

  return response.data as string;
};
